export enum SocialProvider {
  Google = 'google',
  Apple = 'apple',
}
